import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./login.component.scss']
})
export class AccessDeniedComponent {
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  logout(): void {
    if (!this.authService.logout()) {
      this.router.navigate(['/login']);
    }
  }
}
